/**
 * The journal document a coach's save of one exercise writes (#6428), and the kinds of change it
 * lists. Written by client/src/services/coach-exercise-change.service.ts, read through the
 * `exerciseChangeBySubSlot` view. See design-docs/coach-exercise-editing.md.
 */

import { IntensityLevel } from './fitness-plan';

/** the kinds of change one `ExerciseChange` document lists */
export enum ExerciseChangeField {
  Scheme = 'scheme',
  TargetReps = 'target_reps',
  TargetWeight = 'target_weight_kg',
  MinReps = 'min_reps',
  Volume = 'volume',
  Myo = 'myo',
  RmTesting = 'rmTesting',
  SetAsideCleared = 'setAsideCleared',
  PlateauAnswered = 'plateauAnswered',
  VolumeQuestionAnswered = 'volumeQuestionAnswered',
}

/** one line of what changed; `level` names the intensity day for a per-day field */
export interface ExerciseChangeEntry {
  field: ExerciseChangeField;
  level?: IntensityLevel;
  before?: string | number | boolean;
  after?: string | number | boolean;
}

/** who made the change: a coach managing the client, or the user on their own program */
export interface ExerciseChangeAuthor {
  uid: string;
  name: string;
  role: 'coach' | 'self';
}

/**
 * The journal document one save writes per changed sub-slot (`log/<utc>-ExerciseChange`).
 *
 * It has NO `type` field, on purpose: `isDayLogEntry` is `'type' in entry`, and a `type` would pull
 * it into the day view, the backlog and the weekly logic. The text the client reads is worked out
 * from `changes` when it is shown, so it is in the reader's language.
 */
export interface ExerciseChangeDoc {
  _id?: string;
  _rev?: string;
  subSlotId: string;
  exercise_id: string;
  /** equal to the sub-slot's `coachChange_utc` from the same save, so the two compare by equality */
  changed_utc: string;
  author: ExerciseChangeAuthor;
  changes: ExerciseChangeEntry[];
}
